<div class="center" [hidden]="!isLoading">
  <mat-spinner></mat-spinner>
</div>
<div class="ttmodal" *ngIf="isPopup">
  <div class="ttmodal__header">
    <span class="ttmodal__title"></span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
</div>
<div class="panel panel--components" style="margin-bottom: 0px; border-radius: 4px;" [hidden]="isLoading">
  <div class="panel__content no-padding sticky" *ngIf="InspectionHistoryTabular?.length > 0">
    <div class="table-wrapper">
      <div class="column-manage-sticky">
        <button mat-icon-button
                (click)="openColumnDialog()"
                matTooltip="Manage Columns"
                matTooltipPosition="above">
          <mat-icon class="warn">sort</mat-icon>
        </button>

        <button mat-icon-button
                (click)="downloadCsv()"
                matTooltip="Download CSV"
                matTooltipPosition="above">
          <mat-icon class="warn">file_download</mat-icon>
        </button>
      </div>

      <table class="table table--striped table--full-width">
        <thead>
          <tr class="header-row header-row-1">
            <ng-container *ngFor="let group of orderedStaticColumnGroups">

              <th *ngIf="!group.isGroup"
                  rowspan="3"
                  [ngClass]="getColumnHeaderClass(group.columns[0].ColumnKey)">
                {{ getColumnTitle(group.columns[0]) | translate | async }}
              </th>

              <th *ngIf="group.isGroup"
                  [attr.colspan]="group.columns.length"
                  class="text-center text-padding">
                {{ group.title }}
              </th>

            </ng-container>

            <ng-container *ngFor="let group of componentGroups">

              <th *ngIf="!isPositionBasedGroup(group)"
                  [attr.colspan]="getOrderedComponents(group).length"
                  rowspan="2"
                  class="text-center text-padding">
                {{ group.ComponentName | translate | async }}
              </th>

              <th *ngIf="isPositionBasedGroup(group)"
                  [attr.colspan]="getOrderedComponents(group).length"
                  class="text-center text-padding">
                {{ group.ComponentName | translate | async }}
              </th>

            </ng-container>
          </tr>

          <tr class="header-row header-row-2">

            <ng-container *ngFor="let group of orderedStaticColumnGroups">

              <ng-container *ngIf="group.isGroup">

                <ng-container *ngFor="let column of group.columns">

                  <th rowspan="2"
                      class="text-center text-padding">
                    {{ getStaticSideLabel(column) }}
                  </th>

                </ng-container>

              </ng-container>

            </ng-container>


            <ng-container *ngFor="let group of componentGroups">

              <ng-container *ngIf="isPositionBasedGroup(group)">

                <ng-container *ngFor="let position of getUniquePositions(group)">

                  <th [attr.colspan]="getComponentsByPosition(group, position).length"
                      class="text-center text-padding">

                    {{
 formatPosition(
                   position,
                   getComponentsByPosition(group, position)[0]
                 )
                    }}

                  </th>

                </ng-container>

              </ng-container>

            </ng-container>

          </tr>

      <tr class="header-row header-row-3">

            <ng-container *ngFor="let group of componentGroups">

              <ng-container *ngFor="let position of getUniquePositions(group)">

                <ng-container *ngFor="let component of getComponentsByPosition(group, position)">

                  <th class="text-center text-padding">

           
                    <ng-container *ngIf="isEqualiserBar(component, group)">

                      {{ getEqualiserBarLabel(component) }}

                    </ng-container>

          <ng-container *ngIf="!isEqualiserBar(component, group) && !isPositionBasedGroup(group)">

                      <ng-container *ngIf="component.Side === 'Left'">
                        L
                      </ng-container>

                      <ng-container *ngIf="component.Side === 'Right'">
                        R
                      </ng-container>

                    </ng-container>


                    <ng-container *ngIf="!isEqualiserBar(component, group) && isPositionBasedGroup(group)">

                      {{ getPositionSideLabel(component, group) }}

                    </ng-container>

                  </th>

                </ng-container>

              </ng-container>

            </ng-container>

          </tr>

        </thead>


        <tbody>

          <tr class="table-row-style"
              *ngFor="let item of InspectionHistoryTabular">


            <ng-container *ngFor="let column of orderedStaticColumns">

              <td [ngClass]="getColumnCellClass(column.ColumnKey)"
                  title="View inspection details"
                  class="clickable-cell"
                  (click)="openInterpretation(item.InspectionAuto)">

                <ng-container [ngSwitch]="column.ColumnKey">


                  <!-- Jobsite -->
                  <ng-container *ngSwitchCase="'Jobsite'">

                    <span [title]="item.Jobsite">

                      {{ item.Jobsite | slice:0:10 }}

                      <span *ngIf="item.Jobsite?.length > 10">
                        ...
                      </span>

                    </span>

                  </ng-container>


                  <!-- Unit No -->
                  <ng-container *ngSwitchCase="'UnitNo'">

                    <span [title]="item.UnitNo">

                      {{ item.UnitNo | slice:0:10 }}

                      <span *ngIf="item.UnitNo?.length > 10">
                        ...
                      </span>

                    </span>

                  </ng-container>


                  <!-- Inspection Date -->
                  <ng-container *ngSwitchCase="'InspectionDate'">

                    {{ item.InspectionDate | date:'dd-MMM-yyyy' }}

                  </ng-container>


                  <!-- Days Since -->
                  <ng-container *ngSwitchCase="'DaysSince'">

                    {{ item.DaysSince }}

                  </ng-container>


                  <!-- SMU -->
                  <ng-container *ngSwitchCase="'SMUAtInspection'">

                    {{ item.SMUAtInspection | number }}

                  </ng-container>


                  <!-- Difference From Previous SMU -->
                  <ng-container *ngSwitchCase="'DiffFromPrevSMU'">

                    {{ item.DiffFromPrevSMU | number }}

                  </ng-container>


                  <!-- FWD Distance -->
                  <ng-container *ngSwitchCase="'FWDDistance'">

                    {{ item.FWDDistance | number }}

                  </ng-container>


                  <!-- Reverse Distance -->
                  <ng-container *ngSwitchCase="'ReverseDistance'">

                    {{ item.ReverseDistance | number }}

                  </ng-container>


                  <!-- Total Distance -->
                  <ng-container *ngSwitchCase="'TotalDistance'">

                    {{ item.TotalDistance | number }}

                  </ng-container>


                  <!-- FWD Distance Percentage -->
                  <ng-container *ngSwitchCase="'FwdDistancePctFromLastInspection'">

                    {{ item.FwdDistanceChangePercentage }}

                  </ng-container>


                  <!-- FWD Distance Percentage Since Installation -->
                  <ng-container *ngSwitchCase="'FwdDistancePctFromComponentsInstalled'">

                    {{ item.FwdDistanceChangePercentageSinceComponentInstall }}

                  </ng-container>


                  <!-- Difference From Last Distance -->
                  <ng-container *ngSwitchCase="'DiffFromLastDist'">

                    {{ item.DiffFromLastDist | number }}

                  </ng-container>


                  <!-- Inspected By -->
                  <ng-container *ngSwitchCase="'InspectedBy'">

                    <span [title]="item.InspectedBy | aesDecrypt">

                      {{ (item.InspectedBy | aesDecrypt) | slice:0:10 }}

                      <span *ngIf="(item.InspectedBy | aesDecrypt)?.length > 10">
                        ...
                      </span>

                    </span>

                  </ng-container>


                  <!-- Inspection Type -->
                  <ng-container *ngSwitchCase="'InspectType'">

                    <span [title]="item.InspectType">

                      {{ item.InspectType | slice:0:10 }}

                      <span *ngIf="item.InspectType?.length > 10">
                        ...
                      </span>

                    </span>

                  </ng-container>


                  <!-- Frame Serial Left -->
                  <ng-container *ngSwitchCase="'FrameSerialLeft'">

                    <span [title]="item.FrameSerialLeft">

                      {{ item.FrameSerialLeft | slice:0:10 }}

                      <span *ngIf="item.FrameSerialLeft?.length > 10">
                        ...
                      </span>

                    </span>

                  </ng-container>


                  <!-- Frame Serial Right -->
                  <ng-container *ngSwitchCase="'FrameSerialRight'">

                    <span [title]="item.FrameSerialRight">

                      {{ item.FrameSerialRight | slice:0:10 }}

                      <span *ngIf="item.FrameSerialRight?.length > 10">
                        ...
                      </span>

                    </span>

                  </ng-container>


                  <!-- Hours On Frame Left -->
                  <ng-container *ngSwitchCase="'HrsOnFrameLeft'">

                    {{ item.HrsOnFrameLeft | number }}

                  </ng-container>


                  <!-- Hours On Frame Right -->
                  <ng-container *ngSwitchCase="'HrsOnFrameRight'">

                    {{ item.HrsOnFrameRight | number }}

                  </ng-container>


                  <!-- Distance On Frame Left -->
                  <ng-container *ngSwitchCase="'DistanceOnFrameLeft'">

                    {{ item.DistanceOnFrameLeft | number }}

                  </ng-container>


                  <!-- Distance On Frame Right -->
                  <ng-container *ngSwitchCase="'DistanceOnFrameRight'">

                    {{ item.DistanceOnFrameRight | number }}

                  </ng-container>


                  <!-- Track Tension Left -->
                  <ng-container *ngSwitchCase="'TrackTensionLeft'">

                    {{ item.TrackTensionLeft }}

                  </ng-container>


                  <!-- Track Tension Right -->
                  <ng-container *ngSwitchCase="'TrackTensionRight'">

                    {{ item.TrackTensionRight }}

                  </ng-container>


                  <!-- Ice Lug Height Left -->
                  <ng-container *ngSwitchCase="'IceLugHeightLeft'">

                    {{ item.IceLugHeightLeft }}

                  </ng-container>


                  <!-- Ice Lug Height Right -->
                  <ng-container *ngSwitchCase="'IceLugHeightRight'">

                    {{ item.IceLugHeightRight }}

                  </ng-container>





                  <!-- Grouserbar Left -->
                  <!--<ng-container *ngSwitchCase="'GrouserbarLeft'">

                    {{ item.GrouserbarLeft }}

                  </ng-container>-->


                  <!-- Grouserbar Right -->
                  <!--<ng-container *ngSwitchCase="'GrouserbarRight'">

                    {{ item.GrouserbarRight }}

                  </ng-container>-->


                </ng-container>

               
              </td>

            </ng-container>

            <ng-container *ngFor="let group of componentGroups">

              <ng-container *ngFor="let component of getOrderedComponents(group)">

                <td class="text-center text-padding">

                  <div class="component-eval-cell"
                       [style.background-color]="
                   getComponentEvalColor(
                     item.InspectionAuto,
                     component
                   )
                 "
                       [style.color]="
                   getTextColor(
                     getComponentEvalColor(
                       item.InspectionAuto,
                       component
                     )
                   )
                 ">

                    {{
 getComponentValue(
                   item.InspectionAuto,
                   component
                 )
                    }}

                  </div>

                </td>

              </ng-container>

            </ng-container>

          </tr>

        </tbody>

      </table>

    </div>
  </div>
  <div class="panel__content" *ngIf="!isLoading && (!InspectionHistoryTabular || InspectionHistoryTabular.length === 0)">
    <div class="text-center text-padding">
      {{ 'No inspection history found' | translate | async }}
    </div>
  </div>
  <div class="custom-paginator" *ngIf="InspectionHistoryTabular?.length > 0">
    <div class="page-size">
      <span>{{ 'Items per page' | translate | async }}:</span>
      <button mat-button [matMenuTriggerFor]="pageSizeMenu" class="page-size-btn">
        {{ recordsPerPage }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #pageSizeMenu="matMenu" yPosition="above">
        <button mat-menu-item (click)="changePageSize(10)">10</button>
        <button mat-menu-item (click)="changePageSize(25)">25</button>
        <button mat-menu-item (click)="changePageSize(50)">50</button>
        <button mat-menu-item (click)="changePageSize(100)">100</button>
      </mat-menu>
    </div>
    <mat-paginator [hidePageSize]="true" [pageIndex]="pageNumber" [length]="totalResults" [pageSize]="recordsPerPage" (page)="onPageEvent($event)"></mat-paginator>
  </div>
</div>
